module.exports = __webpack_public_path__ + "img/logo.04f2cba0.png";